import React, { useState, useMemo } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Athenahealth from './pages/Athenahealth';
import Flexcar from './pages/Flexcar';
import Wayfair from './pages/Wayfair';
import WorldPay from './pages/Worldpay';
import AmazonRobotics from './pages/AmazonRobotics';
import { Container, CssBaseline, ThemeProvider, createTheme, Button, Box } from '@mui/material';

function App() {
  const [mode, setMode] = useState<'light' | 'dark'>('light');
  const theme = useMemo(() => createTheme({
    palette: {
      mode,
      primary: { main: '#90caf9' },
      secondary: { main: '#f48fb1' },
      background: {
        default: mode === 'dark' ? '#121212' : '#fafafa',
        paper:   mode === 'dark' ? '#121212' : '#fff'
      },
      text: {
        primary:   mode === 'dark' ? '#ffffff' : 'rgba(0,0,0,0.87)',
        secondary: mode === 'dark' ? '#aaaaaa' : 'rgba(0,0,0,0.6)'
      }
    },
    typography: {
      allVariants: {
        color: mode === 'dark' ? '#ffffff' : 'inherit'
      }
    }
  }), [mode]);
  const toggleTheme = () => setMode(prev => prev === 'light' ? 'dark' : 'light');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: theme => theme.zIndex.appBar + 1 }}>
        <Button variant="contained" onClick={toggleTheme}>
          {mode === 'light' ? 'Dark Mode' : 'Light Mode'}
        </Button>
      </Box>
      <Navigation />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/athenahealth" element={<Athenahealth />} />
          <Route path="/flexcar" element={<Flexcar />} />
          <Route path="/wayfair" element={<Wayfair />} />
          <Route path="/worldpay" element={<WorldPay />} />
          <Route path="/amazon-robotics" element={<AmazonRobotics />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
}

export default App;
